import {
  ApplicationConfig,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEchartsCore } from 'ngx-echarts';
import { provideLocalStoragePrefix } from '@ngx-pwa/local-storage';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { provideNzNativeDateAdapter } from 'ng-zorro-antd/core/time';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { MailOutline, LockOutline } from '@ant-design/icons-angular/icons';
import { routes } from './app.routes';
import { icons } from './icons-provider';
import { tokenInterceptor } from './interceptors/token-interceptor';
import { errorInterceptor } from './interceptors/error-interceptor';

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([tokenInterceptor, errorInterceptor])),
    provideLocalStoragePrefix('IMS_'),
    provideNzI18n(en_US),
    provideNzNativeDateAdapter({
      locale: 'en-US',
      firstDayOfWeek: 0,
    }),
    provideNzIcons([MailOutline, LockOutline, ...icons]),
    importProvidersFrom(NzModalModule),
    provideAnimationsAsync(),
    provideEchartsCore({
      echarts: () => import('echarts'),
    }),
  ],
};
